import { FunctionComponent } from 'react';

import LayoutContainer from 'components/layout/LayoutContainer';
import Slick from 'components/layout/Slick';
import MediumArticleBox from 'components/modules/public/layout/articles/MediumArticleBox';
import Description from 'components/modules/public/layout/sections/Description';

import StyledComponent from './styles';
import { Props } from './types';

const PublicPageArticlesEmployeeListSectionArticles: FunctionComponent<Props> = ({
    translations: {
        layoutContainerProps,
        descriptionProps,
        iconsAlts,
    },
    articleCategory,
    articles,
}) => {
    if (!Array.isArray(articles) || articles.length === 0) {
        return null;
    }
    const settings = {
        arrows: true,
        dots: true,
        slidesToShow: articles.length < 3 && articles.length || 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    centerMode: true,
                    slidesToShow: 1,
                },
            },
        ],
    };

    return (
        <StyledComponent className="public-page-articles-employee-list-section-articles">
            <LayoutContainer {...layoutContainerProps}>
                <Description
                    {...{
                        ...descriptionProps,
                        headline: `Kategoria: <a class="category-link" href="${articleCategory?.href}"><b>${articleCategory.name}</b></a>`,
                        buttonProps: {
                            ...descriptionProps.buttonProps,
                            href: articleCategory.href,
                        },
                    }}
                >
                    <div className="article-boxes">
                        <Slick sliderProps={settings}>
                            {articles.map(element => (
                                <MediumArticleBox
                                    key={element?.id}
                                    article={element}
                                    iconsAlts={iconsAlts}
                                />
                            ))}
                        </Slick>
                    </div>
                </Description>
            </LayoutContainer>
        </StyledComponent>
    );
};

export default PublicPageArticlesEmployeeListSectionArticles;